import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=0baff587&"
import script from "./bonus.vue?vue&type=script&lang=js&"
export * from "./bonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports